var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18188_7585)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4H13.5C13.7766 4 14 4.22344 14 4.5V5C14 5.06875 13.9438 5.125 13.875 5.125H12.9312L12.5453 13.2969C12.5203 13.8312 12.0813 14.25 11.5469 14.25H4.45313C3.92031 14.25 3.47969 13.8297 3.45469 13.2969L3.06875 5.125H2.125C2.05625 5.125 2 5.06875 2 5V4.5C2 4.22344 2.22344 4 2.5 4H4.5V2.75C4.5 2.19844 4.94844 1.75 5.5 1.75H10.5C11.0516 1.75 11.5 2.19844 11.5 2.75V4ZM10.375 2.875H5.625V4H10.375V2.875Z",
    fill: "#FF4D4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18188_7585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/Icon-Delete.d5bce00c00ec339a836de1b63cf05f90.svg";
export { ForwardRef as ReactComponent };